export default (name: string) => {
  if(!name) {
    return ''
  }
  return ['k-bg', name].join('-')
}
